import MonthlySummaryError from './MonthlySummaryError';
class MonthlySummaryPropertyNotFound extends MonthlySummaryError {
    propertyId;
    constructor(propertyId, options) {
        super('Crowdfunding property was not found with the received id', options);
        this.propertyId = propertyId;
    }
}
export default MonthlySummaryPropertyNotFound;
